import OBForm from '@/pages/OBForm';
import OBView from '@/pages/OBView';
import OBApproval from '@/pages/OBApproval';

export default [
  {
    path: '/official-business',
    name: 'ob',
    component: OBForm,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_apply_for_ob'],
    },
  },
  {
    path: '/ob/:key',
    name: 'ob.view',
    component: OBView,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_view_own_ob'],
    },
  },
  {
    path: '/ob-approval/:key',
    name: 'ob-approval',
    component: OBApproval,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_approve_ob'],
    },
  },
];
